// extracted by mini-css-extract-plugin
export var alertIcon = "_qu-0";